import React, { useEffect, useState } from "react";
import { Form, Col, Row, Modal } from "react-bootstrap";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import Button from "../../../components/Button";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { getDriverNameLink } from "../../../utils/Standings";
import { Link } from "react-router-dom";
import Flag from "../../../components/Flag";
import { useTranslation } from "react-i18next";
import DataTable from "react-data-table-component";
import moment from "moment";

interface Donation {
  username: string;
  money: number;
  date: Date;
  code: string | null;
  flag: string | null;
}

interface TotalDonnor {
  username: string;
  money: number;
  code: string | null;
  flag: string | null;
  last_date: Date;
  first_date: Date;
  total: number;
  row_num: number;
}

const Donors = () => {
  const { t } = useTranslation();
  const { access } = useIsAdmin();
  document.title = "LVF1 - Donors";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [theme, setTheme] = useState("light");

  const [users, setUsers] = useState<User[]>();
  const [update, setUpdate] = useState(false);
  const [update2, setUpdate2] = useState(false);
  const [typeTable, setTypeTable] = useState(-1);
  const [donations, setDonations] = useState<Donation[]>();
  const [totalDonnors, setTotalDonnors] = useState<TotalDonnor[]>();
  const [showModal, setShowModal] = useState(false);
  const [total, setTotal] = useState(0);
  const [columns, setColumns] = useState<ColumnData[]>([]);
  const [rows, setRows] = useState<{ [key: string]: any }[]>([]);

  const [formData, setFormData] = useState({
    date: "",
    amount: "",
    pilotType: "select",
    pilot: "",
  });

  const [selectedUser, setSelectedUser] = useState<User>();
  const [selectedOption, setSelectedOption] = useState(
    users?.find((user) => user.id === selectedUser?.id) || null,
  );

  useEffect(() => {
    const theme_ = window.localStorage.getItem("theme");
    setTheme(theme_ != null && theme_ === "light" ? "dark" : "light");
  }, [window.localStorage.getItem("theme")]);

  const options: any = users?.map((user: any) => ({
    value: user.id,
    label: user.username,
  }));

  const inputChange = ({ target }: { target: any }) => {
    const { name, value } = target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    let rows_: any = [];
    if (typeTable === 1) {
      let columns_: ColumnData[] = [
        {
          name: "#",
          selector: (row: { [key: string]: any }) => row.pos,
          sortable: true,
          width: "100px",
        },
        {
          name: "User",
          selector: (row: { [key: string]: any }) => row.name,
          sortable: true,
          width: "280px",
        },
        {
          name: "Money (€)",
          selector: (row: { [key: string]: any }) => row.money,
          sortable: true,
          width: "150px",
        },
        {
          name: "First Donation",
          selector: (row: { [key: string]: any }) => row.first_date,
          sortable: true,
          width: "180px",
        },
        {
          name: "Last Donation",
          selector: (row: { [key: string]: any }) => row.last_date,
          sortable: true,
          width: "180px",
        },
        {
          name: "Total Donations",
          selector: (row: { [key: string]: any }) => row.total,
          sortable: true,
          width: "150px",
        },
      ];
      setColumns(columns_);

      totalDonnors?.forEach((driver: TotalDonnor) => {
        let row_: { [key: string]: any } = {
          pos: driver.row_num,
          money: driver.money.toFixed(2),
          first_date: moment(driver.first_date).format("YYYY-MM-DD"),
          last_date: moment(driver.last_date).format("YYYY-MM-DD"),
          total: driver.total,
          name: (
            <>
              {driver.code === null ? (
                <label>{driver.username}</label>
              ) : (
                <>
                  <Flag flag_code={driver.code} name={driver.flag} />
                  <Link
                    className="driver"
                    to={`${t("routes:Driver")}/${encodeURIComponent(
                      driver.username,
                    )}`}
                  >
                    {driver.username}
                  </Link>
                </>
              )}
            </>
          ),
        };
        rows_.push(row_);
      });
    } else {
      let columns_: ColumnData[] = [
        {
          name: "User",
          selector: (row: { [key: string]: any }) => row.name,
          sortable: true,
          width: "280px",
        },
        {
          name: "Money (€)",
          selector: (row: { [key: string]: any }) => row.money,
          sortable: true,
          width: "150px",
        },
        {
          name: "Date",
          selector: (row: { [key: string]: any }) => row.date,
          sortable: true,
          width: "180px",
        },
      ];
      setColumns(columns_);

      donations?.forEach((driver: Donation) => {
        let row_: { [key: string]: any } = {
          money: driver.money,
          date: moment(driver.date).format("YYYY-MM-DD"),
          name: (
            <>
              {driver.code === null ? (
                <label>{driver.username}</label>
              ) : (
                <>
                  <Flag flag_code={driver.code} name={driver.flag} />
                  <Link
                    className="driver"
                    to={`${t("routes:Driver")}/${encodeURIComponent(
                      driver.username,
                    )}`}
                  >
                    {driver.username}
                  </Link>
                </>
              )}
            </>
          ),
        };
        rows_.push(row_);
      });
    }
    setRows(rows_);
  }, [update2]);

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/user/getDonors`,
      )
      .then(({ data }) => {
        setSelectedUser(data.users[0]);
        setUsers(data.users);
        setDonations(data.donations);
        setTotalDonnors(data.totalDonnors);
        setTypeTable(1);
        setUpdate2(!update2);

        var total = 0;
        data.totalDonnors.forEach((data: any) => {
          total += data.money;
        });
        setTotal(total);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, [update]);

  const handleSubmit = (event: React.FormEvent) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();

    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);
    formDataFiles.append("date", formData.date);
    formDataFiles.append("amount", formData.amount);
    formDataFiles.append("pilotType", formData.pilotType);
    formDataFiles.append("pilot", formData.pilot);

    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/addDonor`,
        formDataFiles,
      )
      .then(() => {
        toast.success("Donnor added successfully");
        setUpdate(!update);
        setShowModal(false);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        throw new Error(response);
      });
  };

  const handleChange = (option: any) => {
    setSelectedOption(option);

    // Crea un evento sintético para pasar los datos al formulario original
    const syntheticEvent = {
      target: { name: "pilot", value: option?.value },
    };

    inputChange(syntheticEvent);
  };

  if (!access) return <ErrorPage />;

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container-md overflowed">
        <Title text="Donors" />

        {/* BOTÓN */}
        <Button text={"Add Donation"} onClick={() => setShowModal(true)} />

        {/* MODAL */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Donation</Modal.Title>
          </Modal.Header>

          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Row className="mb-3">
                <Col>
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={(e) => inputChange(e)}
                    required
                  />
                </Col>

                <Col>
                  <Form.Label>Money (€)</Form.Label>
                  <Form.Control
                    type="number"
                    name="amount"
                    value={formData.amount}
                    onChange={(e) => inputChange(e)}
                    required
                  />
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Driver / Name</Form.Label>
                <Form.Select
                  name="pilotType"
                  value={formData.pilotType}
                  onChange={(e) => inputChange(e)}
                >
                  <option value="select">LVF1 Users</option>
                  <option value="text">Write Name</option>
                </Form.Select>
              </Form.Group>

              {formData.pilotType === "select" ? (
                <Form.Group className="mb-3">
                  <Form.Label>Driver</Form.Label>
                  <Select
                    name="pilot"
                    options={options}
                    value={selectedOption}
                    onChange={handleChange}
                    placeholder="Select an user..."
                    isClearable
                    required
                  />
                </Form.Group>
              ) : (
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="pilot"
                    placeholder="Nombre del piloto"
                    value={formData.pilot}
                    onChange={(e) => inputChange(e)}
                    required
                  />
                </Form.Group>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button
                text={"Close"}
                onClick={() => setShowModal(false)}
                className="button-neutral-lvf1"
              />
              <Button text={"Save Donation"} type="submit" />
            </Modal.Footer>
          </Form>
        </Modal>
        <div className="flex-center">
          <div className="table-stats-container relative table-donors">
            <Button
              text={typeTable === 1 ? "Show all Donations" : "Show Summary"}
              onClick={() => {
                setTypeTable(typeTable === 1 ? 0 : 1);
                setUpdate2(!update2);
              }}
              className="button-neutral-lvf1"
            />

            <div className={`table-donors-${typeTable}`}>
              <DataTable
                columns={columns}
                data={rows}
                pagination
                theme={theme}
                paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                paginationComponentOptions={{
                  selectAllRowsItem: true,
                  selectAllRowsItemText: t("All"),
                  rowsPerPageText: t("RowsPerPage"),
                  rangeSeparatorText: t("of"),
                }}
              />
            </div>
          </div>
        </div>
        <p id="balance-text">
          TOTAL DONATIONS: <span className="green">{total.toFixed(2)} €</span>
        </p>
      </div>
    </div>
  );
};

export default Donors;
